export const socialOptions = [
    { id: 'website', name: 'Website', icon: '/media/svg/nobilis/web.svg', icon2: '/media/svg/nobilis/web_01.svg' },
    { id: 'linkedin', name: 'Linkedin', icon: '/media/svg/nobilis/lk.svg', icon2: '/media/svg/nobilis/lk_01.svg' },
    { id: 'instagram', name: 'Instagram', icon: '/media/svg/nobilis/instagram.svg', icon2: '/media/svg/nobilis/insta_01.svg' },
    { id: 'facebook', name: 'Facebook', icon: '/media/svg/nobilis/fb-black.svg', icon2: '/media/svg/nobilis/fb_01.svg' },
    { id: 'twitter', name: 'X Profile', icon: '/media/svg/nobilis/x.svg', icon2: '/media/svg/nobilis/x_01.svg' }
];
